import React from 'react';
import Tooltip, { TooltipProps } from 'src/design-system/components/atoms/Tooltip/Tooltip';
import Typography from 'src/design-system/components/atoms/Typography/Typography';

const { Text } = Typography;

export interface TextWithEllipsisAndTooltipProps {
  children: React.ReactNode;
  width?: string | number;
  placement?: TooltipProps['placement'];
}

const TextWithEllipsisAndTooltip: React.FC<TextWithEllipsisAndTooltipProps> = ({
  children,
  width,
  placement = 'top'
}) => {
  return (
    <Tooltip placement={placement} title={children}>
      <Text style={{ width }} ellipsis={true}>
        {children}
      </Text>
    </Tooltip>
  );
};

export default TextWithEllipsisAndTooltip;
